import { GlobalState } from './Global.interface';

type GlobalAction = {
    type:
        | 'setLoggedIn'
        | 'setLoading'
        | 'setStoreId'
        | 'setRoomColors'
        | 'setAuthSetting'
        | 'setAuthTimerCount'
        | 'setAdmissionFee'
        | 'setIsChangeAccount'
        | 'setProfile'
        | 'setTitlePage'
        | 'setIsLoggedAuth';
    payload: any;
};

export const globalReducer = (state: GlobalState, action: GlobalAction): GlobalState => {
    switch (action.type) {
        case 'setLoggedIn':
            return {
                ...state,
                isLoggedIn: action.payload,
            };
        case 'setLoading':
            return {
                ...state,
                isLoading: action.payload,
            };
        case 'setRoomColors':
            return {
                ...state,
                roomColors: action.payload,
            };
        case 'setProfile':
            return {
                ...state,
                profile: action.payload,
            };
        case 'setTitlePage':
            return {
                ...state,
                titlePage: action.payload,
            };
        case 'setIsLoggedAuth':
            return {
                ...state,
                isLoggedAuth: action.payload,
            };
        default:
            return state;
    }
};
